import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, mergeMap } from 'rxjs';
import { Authentication } from './authentication.service';
import { ErrorHandlingService } from './error-handling.service';
import * as uuid from 'uuid';
import { throwError } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  correlationId = uuid.v4();
  constructor(
    private authService: Authentication,
    private errorHandlingService: ErrorHandlingService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!navigator.onLine) {
      this.errorHandlingService.showError('No internet connection or network error');
      const error = new HttpErrorResponse({
        error: 'No internet connection',
        status: 0,
        statusText: 'No Internet Connection',
        url: request.url,
      });
      return this.errorHandlingService.handleError(error, error.url);
    }
    if (
      request.url.includes('/auth/token') ||
      request.url.includes('/account/token') ||
      request.url.includes('/account/reset') ||
      request.url.includes('/auth/google/login') ||
      request.url.includes('/auth/microsoft/callback')
    ) {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          return this.errorHandlingService.handleError(error, error.url);
        }),
      );
    }
    if (request.url) {
      if (this.authService.isTokenValid()) {
        request = this.addAuthorizationHeader(request);
        return next.handle(request).pipe(
          catchError((error: HttpErrorResponse) => {
            return this.errorHandlingService.handleError(error, error.url, request);
          }),
        );
      } else {
        return this.refreshTokenAndRetry(request, next);
      }
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandlingService.showError(error.error);
        return throwError(() => error);
      }),
    );
  }

  private addAuthorizationHeader(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.authService.getAccessToken();
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'X-Correlation-ID': this.correlationId,
      },
    });
  }

  private refreshTokenAndRetry(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.authService.whitelistedUrls()) {
      return this.authService.refreshTokenAndRetry().pipe(
        mergeMap((response) => {
          const newAccessToken = response.access_token;
          const newRefreshToken = response.refresh_token;
          localStorage.setItem('access_token', newAccessToken);
          localStorage.setItem('refresh_token', newRefreshToken);
          this.correlationId = uuid.v4();
          request = this.addAuthorizationHeader(request);
          return next.handle(request);
        }),
        catchError((error: HttpErrorResponse) => {
          return this.errorHandlingService.handleError(error, error.url);
        }),
      );
    } else {
      return next.handle(request.clone());
    }
  }
}
